import {productCartIcon} from "../../../../assets";
import s from "./nadLock.module.css";
import {Fragment, h} from "preact";

const NadLock = (props) => {
    // Nad checkout redirect button variable
    const nadCheckoutButton = (
        <button
            type={"button"}
            className={`${s.addToCartButton}`}
            onClick={() => window.location.replace("/checkout")}
        >
            <img
                src={productCartIcon}
                className={`${s.cartIcon}`}
                alt={"Cart icon"}
            />
            <p>
                Ir para o checkout
            </p>
        </button>
    );

    return (
        <div className={`font-museo ${s.root}`}>
            <h1 className={`font-bold`}>
                Você já possui um orçamento em aberto. Finalize-o ou cancele-o para adicionar novos
                itens ao
                carrinho.
            </h1>
            {nadCheckoutButton}
        </div>
    )
}

export default NadLock;
